<template>
  <page-edicion>
    <page-header :title="pageTitle" subtitle="Usuarios" back-to="/usuarios" />
    <b-form autocomplete="off" @submit.prevent="guardar">
      <input style="display: none" type="text" name="fakeusername" />
      <input style="display: none" type="password" name="fakepassword" />
      <b-row>
        <b-col lg="6" md="12" sm="12">
          <b-form-group label="Nombre">
            <b-form-input
              v-model="usuario.nombre"
              :read-only="usuario.bloqueado"
              required
              type="text"
              placeholder="Nombre del usuario"
            />
          </b-form-group>
          <b-form-group label="Email">
            <b-form-input
              v-model="usuario.email"
              :read-only="usuario.bloqueado"
              required
              type="email"
              placeholder="Email del usuario"
            />
          </b-form-group>
          <b-form-group label="Contraseña">
            <b-form-input
              v-model="usuario.claveNueva"
              :read-only="usuario.bloqueado"
              type="password"
              autocomplete="new-password"
              placeholder="Contraseña"
            />
          </b-form-group>
        </b-col>
        <b-col lg="6" md="12" sm="12">
          <b-form-group label="Teléfono">
            <b-form-input
              v-model="usuario.telefono"
              :read-only="usuario.bloqueado"
              type="text"
              autocomplete="telefono"
              placeholder="Teléfono del usuario"
            />
          </b-form-group>
          <b-form-group label="Móvil">
            <b-form-input
              v-model="usuario.movil"
              :read-only="usuario.bloqueado"
              type="text"
              autocomplete="movil"
              placeholder="Móvil del usuario"
            />
          </b-form-group>
          <b-form-group label="Cargo">
            <b-form-input
              v-model="usuario.cargo"
              :read-only="usuario.bloqueado"
              required
              type="text"
              autocomplete="cargo"
              placeholder="Cargo del usuario"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col lg="6" md="12" sm="12">
          <campo-imagen
            v-model="imagenes.rutaImagenAvatar"
            :disabled="usuario.bloqueado"
            title="Avatar"
            placeholder="Elige una foto (máx. 200x200) y arrástrala aquí..."
          />
        </b-col>
        <b-col lg="6" md="12" sm="12">
          <campo-imagen :disabled="usuario.bloqueado" title="Firma" v-model="imagenes.rutaImagenFirma" />
        </b-col>
      </b-row>

      <h3>Configuración y roles</h3>
      <b-form-group>
        <b-form-checkbox switch v-model="usuario.bloqueado"> Bloqueado </b-form-checkbox>
        <b-form-checkbox switch v-model="usuario.esAdmin" :disabled="usuario.bloqueado">
          Administrador
        </b-form-checkbox>
        <b-form-checkbox switch v-model="usuario.esPartner" :disabled="usuario.bloqueado || usuario.esAdmin">
          Partner
        </b-form-checkbox>
        <b-form-checkbox switch v-model="usuario.esRevisor" :disabled="usuario.bloqueado || usuario.esAdmin">
          Puede visar ofertas
        </b-form-checkbox>
      </b-form-group>

      <h3>Unidad de negocio</h3>
      <b-form-group label="Responsable de las unidades de negocio">
        <combo-multiple
          v-model="unidadesNegocioResponsable"
          :options="unidadesNegocioCombo"
          :disabled="usuario.bloqueado"
        />
      </b-form-group>

      <b-form-group label="Comercial en las unidades de negocio">
        <combo-multiple
          v-model="unidadesNegocioComercial"
          :options="unidadesNegocioCombo"
          :disabled="usuario.bloqueado"
        />
      </b-form-group>

      <b-row>
        <b-col>
          <p>Creado el {{ formatDateEs(usuario.creadoEl) }}</p>
        </b-col>
        <b-col>
          <botonera-edicion url-cancelar="/usuarios" />
        </b-col>
      </b-row>
    </b-form>
  </page-edicion>
</template>
<script>
import { formatDateEs } from "@/services/date";
import * as usuarioApi from "@/services/usuarios.js";
import * as unidadesNegocioApi from "@/services/unidadesNegocio";

export default {
  data() {
    return {
      usuario: usuarioApi.crear(),
      imagenes: {
        rutaImagenAvatar: {},
        rutaImagenFirma: {},
      },
      unidadesNegocioResponsable: [],
      unidadesNegocioComercial: [],
      unidadesNegocio: [],
      descuentos: [],
      opcionesDescuentos: [],
    };
  },
  computed: {
    pageTitle() {
      if (this.usuario.id > 0) {
        return this.usuario.nombre;
      } else {
        return "Crear usuario";
      }
    },
    descuentosCombo() {
      return [];
    },
    unidadesNegocioCombo() {
      return this.unidadesNegocio.map((x) => {
        return { id: x.id, text: x.nombreComercial };
      });
    },
  },
  methods: {
    formatDateEs,
    async cargarMaestros() {
      this.unidadesNegocio = await unidadesNegocioApi.listar();
    },
    async cargar(id) {
      const response = await usuarioApi.cargar(id);
      this.usuario = response.usuario;
      this.imagenes = response.imagenes;
      this.unidadesNegocioResponsable = response.unidadesNegocioResponsable;
      this.unidadesNegocioComercial = response.unidadesNegocioComercial;
      this.descuentos = response.descuentos;
    },
    guardar() {
      if (this.usuario.id) {
        return this.actualizar();
      } else {
        return this.insertar();
      }
    },
    async insertar() {
      const usuarioCompleto = {
        usuario: this.usuario,
        imagenes: this.imagenes,
        unidadesNegocioResponsable: this.unidadesNegocioResponsable,
        unidadesNegocioComercial: this.unidadesNegocioComercial,
        descuentos: this.descuentos,
      };

      await usuarioApi.insertar(usuarioCompleto).then(() => {
        this.$messages.success("Se ha creado el usuario");
        this.$router.push({ path: "/usuarios" });
      });
    },
    async actualizar() {
      var usuarioCompleto = {
        usuario: this.usuario,
        imagenes: this.imagenes,
        unidadesNegocioResponsable: this.unidadesNegocioResponsable,
        unidadesNegocioComercial: this.unidadesNegocioComercial,
        descuentos: this.descuentos,
      };

      await usuarioApi.actualizar(usuarioCompleto).then(() => {
        this.$messages.success("Se ha actualizado el usuario");
        this.$router.push({ path: "/usuarios" });
      });
    },
  },
  async mounted() {
    await this.cargarMaestros();

    const id = this.$route.params.id;
    if (id) {
      await this.cargar(id);
    }
  },
};
</script>
